import React, { createContext, useContext, useState } from 'react';
import { UserSessionDTO } from '../../../dto/locationcash/LocationCashDTO';

type ViewType = 'selection' | 'active' | 'movements';

interface LocationDeskContextValue {
    currentView: ViewType;
    setCurrentView: (v: ViewType) => void;
    activeSession: UserSessionDTO | null;
    setActiveSession: (s: UserSessionDTO | null) => void;
    activeLocationId: number | null;
    setActiveLocationId: (id: number | null) => void;
    currentUserId: number | null;
    setCurrentUserId: (id: number | null) => void;
    movementsLocationId: number | null;
    navigateToMovements: (hospitalLocationId: number) => void;
    returnFromMovements: () => void;
}

const LocationDeskContext = createContext<LocationDeskContextValue | undefined>(undefined);

export const useLocationDeskContext = () => {
    const context = useContext(LocationDeskContext);
    if (!context) throw new Error("useLocationDeskContext debe usarse dentro de LocationDeskProvider");
    return context;
};

export const LocationDeskProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [currentView, setCurrentView] = useState<ViewType>('selection');
    const [activeSession, setActiveSession] = useState<UserSessionDTO | null>(null);
    const [activeLocationId, setActiveLocationId] = useState<number | null>(null);
    const [currentUserId, setCurrentUserId] = useState<number | null>(null);
    const [movementsLocationId, setMovementsLocationId] = useState<number | null>(null);
    const [previousView, setPreviousView] = useState<ViewType>('selection');

    const navigateToMovements = (hospitalLocationId: number) => {
        setPreviousView(currentView);
        setMovementsLocationId(hospitalLocationId);
        setCurrentView('movements');
    };

    const returnFromMovements = () => {
        setMovementsLocationId(null);
        setCurrentView(previousView);
    };

    return (
        <LocationDeskContext.Provider value={{
            currentView,
            setCurrentView,
            activeSession,
            setActiveSession,
            activeLocationId,
            setActiveLocationId,
            currentUserId,
            setCurrentUserId,
            movementsLocationId,
            navigateToMovements,
            returnFromMovements,
        }}>
            {children}
        </LocationDeskContext.Provider>
    );
};
